import * as React from 'react';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import * as controller from '../client/controller'
import { withLocalize } from "react-localize-redux";

class Clients extends React.Component<any, any> {
  searchString: any

  constructor(props: any) {
    super(props);
    this.state = {
      clients: [],
      clientsFiltered: []
    }
  }

  search() {
      let clientsFiltered = this.state.clientsFiltered
      clientsFiltered = this.state.clients.filter((client: any) => {
        return client.name.includes(this.searchString.value.trim())
      })
      this.setState({clientsFiltered})
  }

  loadClients() {
    fetch('clients/getAll', {
      method: 'POST'
    }).then(results => {
      return results.json();
    }).then(data => {
        let clients = data.clients
        this.setState({clients, clientsFiltered: clients})
    }).catch(err => {
      //alert(err.message);
    })
  }

  componentDidMount() {

  }

  componentWillMount() {
    //Only admins can see this page
    if(window.account.type != "admin")
      this.props.history.push("/login/admin")


    this.loadClients()
  }

  componentWillUnmount() {
  }


  public render() {
    const columns = [{
      Header: '#',
      accessor: 'id',
      maxWidth: 80,
      resizable: false
    }, {
      Header: this.props.translate("name").toString(),
      accessor: 'name'
    }, {
      Header: this.props.translate("email").toString(),
      accessor: 'email'
    }, {
      Header: this.props.translate("phone").toString(),
      accessor: 'phone'
    }, {
      id: 'הגדרות',
      Header: this.props.translate("settings").toString(),
      sortable: false,
      maxWidth: 100,
      resizable: false,
      accessor: (d:any) => d,
      Cell: (row:any) => <div>
        <Link to={"/clients/" + row.value.id}><i className="fas fa-edit"></i></Link>
        {window.account.privilege == "admin" && <i onClick={controller.removeClient.bind(this, row.value.id, row.index)} className="fas fa-trash-alt"></i>}
      </div>
    }]

    return (
      <div id="clients-root">

        <input className="search" type="text" placeholder={this.props.translate("client.searchByName").toString()} onChange={this.search.bind(this)} ref={(searchString:any) => this.searchString = searchString} />

        <div className="board">
          <ReactTable
            data={this.state.clientsFiltered}
            columns={columns}
            defaultPageSize={10}
            noDataText={this.props.translate("noResults").toString()}
            nextText={this.props.translate("next").toString()}
            previousText={this.props.translate("previous").toString()}
            rowsText={this.props.translate("rows").toString()}
            pageText={this.props.translate("page").toString()}
            ofText={this.props.translate("of").toString()}
            style={{
              height: "400px",
              textAlign: "center",
              fontSize: "1em",
              position: "centner",
              right: "0",
              left: "0",
              margin: "0 auto"
            }}
            className="-striped -highlight reactTable"
          />
        </div>
      </div>
    )
  }

}

export default withLocalize(Clients)



// WEBPACK FOOTER //
// ./src/pages/clients/Clients.tsx